module.exports = __webpack_public_path__ + "img/20191130133859285.97505cfd.jpg";